export default __webpack_public_path__ + "static/media/arte-popup.905215ef.jpg";